
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import translations from './PriceFilter.translations'
import VisualPrice from './VisualPrice/VisualPrice.vue'

const PRICE_KEY = 'price'
const MIN_ABSOLUTE = 0

export default {
  components: {
    VisualPrice,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    tracking: {
      type: String,
      default: 'price',
    },
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      avgPrice: 'landingSearch/avgPrice',
      maxRange: 'landingSearch/maxRange',
    }),

    maxAbsolute() {
      return parseInt(this.maxRange, 10)
    },

    minAbsolute() {
      return MIN_ABSOLUTE
    },

    roundedUpAvgPrice() {
      return Math.ceil(this.avgPrice)
    },

    minState() {
      if (PRICE_KEY in this.filters) {
        const min = parseInt(this.filters[PRICE_KEY][0], 10)
        if (min <= this.maxAbsolute && min >= this.minAbsolute) {
          return min
        }
      }

      return this.minAbsolute
    },

    maxState() {
      if (PRICE_KEY in this.filters) {
        const max = parseInt(this.filters[PRICE_KEY][1], 10)
        if (max <= this.maxAbsolute && max >= this.minAbsolute) {
          return max
        }
      }

      return this.maxAbsolute
    },
  },
  watch: {
    maxRange(newMax, oldMax) {
      // Sometime the context search is empty in the store
      // when the page stay open during some minutes. (date validaty is expired)
      // So we need to backup the maxAbsolute
      if (parseInt(newMax, 10) === 0) {
        this.maxRange = parseInt(oldMax, 10)
      }
    },
  },
  methods: {
    selectPrice(value) {
      this.$emit('change', {
        [PRICE_KEY]: value,
      })
    },

    updatePrice({ value, name }) {
      if (this.minState !== value[0]) {
        trackClick({
          name: `min${name}`,
          value: value[0],
          zone: `${this.tracking}Filter`,
        })
        this.selectPrice(value)
      }
      if (this.maxState !== value[1]) {
        trackClick({
          name: `max${name}`,
          value: value[1],
          zone: `${this.tracking}Filter`,
        })
        this.selectPrice(value)
      }
    },
  },
}
